import { RemovingThrobber } from "../../../removing_throbber";
import { SeshAddonInput } from "../../base_components/sesh_addon_input";
import { SettingsBaseItem } from "../../settings_items/settings_base_item";
import {
	UserPreferenceModifiableSettings,
	useUserPreferencesMutation,
} from "../user_preferences_modal";

export function UserPreferencesAddonItem(props: {
	setting_key: UserPreferenceModifiableSettings;
	label: string;
	description: string;
	value: boolean;
}) {
	const mutation = useUserPreferencesMutation(props.setting_key);

	return (
		<SettingsBaseItem {...props}>
			<div className="flex w-fit gap-2">
				{mutation.isLoading && <RemovingThrobber />}
				<SeshAddonInput
					size="sm"
					is_disabled={mutation.isLoading}
					value={!!props.value}
					setValue={(t) => {
						mutation.mutate({
							[props.setting_key]: t,
						});
					}}
					buttons={[
						{
							label: "Server",
							value: false,
						},
						{
							label: "Personal",
							value: true,
						},
					]}
				/>
			</div>
		</SettingsBaseItem>
	);
}
